<template>
  <router-view/>
</template>
<script>
export default {
  name: 'ParentView'
}
</script>



// WEBPACK FOOTER //
// src/components/parent-view/parent-view.vue